/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  APUCustomerTypes.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Srinivas Grandhi (E528634)
 *
 * @Date	     : Sep 25, 2019
 *
 * @Version      : Version 1.0
 *
 * By           : Srinivas Grandhi (E528634)
 * On           : Sep 26, 2019
 * Description  : Updated code as per ASDS-1022
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 03, 2019
 * Description  : Updated code as per ASDS-1470
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 10, 2019
 * Description  : Updated code as per ASDS-1471
 *
 * By           : Sandeepraja (E807238  )
 * On           : Oct 15, 2019
 * Description  : ASDS-1551:  Modal screen Validations (MSA & Non MSA)
 *
 * By           : H224423
 * On           : Nov 20, 2019
 * Description  : Made stepper responsive. ASDS-1304 changes.
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : ASDS-2083 - APU MSA UI changes
 *
 ******************************************************************************/

import * as React from 'react';
import { Card, Radio } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import './APUCustomerTypes.css';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import CheckoutConstants from '../constants/checkout-constants';

interface ICustomerTypeProps {
    saveCustomerType: Function;
    APUCustomerType: string;
}

class APUCustomerTypes extends React.Component<ICustomerTypeProps, any> {
    constructor(props: ICustomerTypeProps) {
        super(props);

        this.handleChangeEvent = this.handleChangeEvent.bind(this);
    }

    handleChangeEvent = (custType) => {
        this.setState({
            APUCustomerType: custType,
        });

        this.props.saveCustomerType(custType);
    }

    componentDidMount() {
        const custType = this.props.APUCustomerType;
        this.props.saveCustomerType(custType);
    }

    render() {
        return (
                        <Card>
                            <Card.Content>
                                <div>
                                <span  className="customerCategoryHeader"> Is the APU you are configuring covered under a MSA Contract? </span>
                                </div>
                                <div className="radioDiv">
                                <Radio name="RadioGroup"  checked={this.props.APUCustomerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA}
                                                onChange={() => this.handleChangeEvent(CheckoutConstants.CUSTOMER_CATEGORY_MSA)}
                                            />
                                            <p className="radioText"> Yes </p>
                                <Radio name="RadioGroup"
                                                 checked={this.props.APUCustomerType === CheckoutConstants.CUSTOMER_CATEGORY_NONMSA}
                                                 onChange={() => this.handleChangeEvent(CheckoutConstants.CUSTOMER_CATEGORY_NONMSA)}
                                             />
                                            <p className="radioText"> No </p>
                                </div>

                            </Card.Content>
                        </Card>
        );
    }
}

const mapDispatchToProps = {
    saveCustomerType: ConfigureAPUActions.saveCustomerType,
};

function mapStateToProps(state) {
    return {
        APUCustomerType: state.configAPUData.payload.customerType,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(APUCustomerTypes);